export default "__VITE_ASSET__CALqO9pq__"